import { userApi } from '@texas/api/endpoints/userApi';
import { VerifyDialogWithRequest } from '@texas/components/shared/dialog/VerifyDialogWithRequest';
import { SharedDisclosureProps } from '@texas/components/shared/types';
import { Trans, useTranslation } from 'react-i18next';

interface Props extends SharedDisclosureProps {
  onArchive: () => void;
  user: { id: number; email: string };
}

export function ArchiveUser({ isOpen, user, onArchive, onClose }: Props) {
  const { t } = useTranslation();
  return (
    <VerifyDialogWithRequest
      headerTitle={t('user.archiveUser')}
      secondaryButtonTitle={t('general.cancel')}
      primaryButtonTitle={t('general.confirm')}
      primaryRequest={userApi.archive}
      args={[user.id]}
      isOpen={isOpen}
      onClose={onClose}
      onPerformed={onArchive}
      onSuccessTitle={t('general.entityArchived', { name: user.email })}
    >
      <Trans i18nKey="user.archiveEmail" values={{ email: user.email }} />
    </VerifyDialogWithRequest>
  );
}
